import {
  ActionIcon, DetailItemList, HStack, ICON_ACCOUNT_OUTLINE, ICON_EMAIL_OUTLINE, ICON_EYE_OUTLINE, ICON_PHONE_OUTLINE, Spacing,
} from '@doveit/bricks';
import React from 'react';
import Card from '../../../components/card/Card';
import UserActions from '../../../components/user-actions/UserActions';
import { Contact } from '../../../providers/api/dtos/contact';
import ProcessContact from '../process-contact/ProcessContact';
import useRBAC from '../../../hooks/use-rbac/useRBAC';
import ViewContactAction from '../view-contact-action/ViewContactAction';

export interface SearchContactCardProps {
  contact: Contact,
}

const SearchContactCard: React.FC<SearchContactCardProps> = ({
  contact,
}) => {
  const { userIsAdmin, userIsCallCenter } = useRBAC();
  const showProcessAction = React.useMemo(() => (userIsAdmin || userIsCallCenter), [userIsAdmin, userIsCallCenter]);

  return (
    <Card key={contact.id}>
      <Card.Inline>
        <Card.Box aria-label="Informazioni del contatto">
          <DetailItemList>
            <DetailItemList.Item
              icon={ICON_ACCOUNT_OUTLINE}
            >
              {contact.name}
            </DetailItemList.Item>
            <DetailItemList.Item
              icon={ICON_PHONE_OUTLINE}
            >
              {contact.phoneNumber}
            </DetailItemList.Item>
            <DetailItemList.Item
              icon={ICON_EMAIL_OUTLINE}
            >
              {contact.email}
            </DetailItemList.Item>
          </DetailItemList>
          <Spacing margin={[100, 0, 0]}>
            <UserActions user={contact} />
          </Spacing>
        </Card.Box>

        <Card.ColumnDivider />

        <Card.Box fit>
          <HStack>
            <ViewContactAction contactId={contact.id!}>
              {({ onClick }) => (
                <ActionIcon
                  label="Visualizza"
                  aria-label="Azione per visualizzare la pagina del contatto"
                  icon={{ path: ICON_EYE_OUTLINE }}
                  onClick={onClick}
                />
              )}
            </ViewContactAction>
            {showProcessAction && (
              <ProcessContact
                contact={contact}
              />
            )}
          </HStack>
        </Card.Box>
      </Card.Inline>
    </Card>
  );
};

export default SearchContactCard;
